import React from "react";
import { Box, Tooltip, UnstyledButton } from "@mantine/core";
import { useCalendar } from "../../../../../context/CalendarContext";
import { ZOOM_MAX, ZOOM_MIN, ZOOM_STEP } from "../../../../../types/calendar";
import { DESIGN_ICONS } from "../../../../../theme/designIcons";
import styles from "./CalendarToolbar.module.css";

const { Minus, Plus } = DESIGN_ICONS;

/**
 * − / 100% / + grid zoom (Day / Week). Lives in the RBC toolbar, so the zoom
 * comes from CalendarContext. Clicking the label resets to 100%.
 */
const ZoomControl: React.FC = () => {
  const { zoom, setZoom } = useCalendar();
  return (
    <Tooltip label="Zoom — or hold Ctrl/⌘ and scroll" withArrow openDelay={300}>
      <Box className={styles.zoomControl} role="group" aria-label="Zoom">
        <UnstyledButton
          className={styles.zoomStep}
          onClick={() => setZoom(zoom - ZOOM_STEP)}
          disabled={zoom <= ZOOM_MIN}
          aria-label="Zoom out"
        >
          <Minus size={15} />
        </UnstyledButton>
        <UnstyledButton
          className={styles.zoomLabel}
          onClick={() => setZoom(1)}
          title="Reset to 100% (6.5 hours)"
        >
          {`${Math.round(zoom * 100)}%`}
        </UnstyledButton>
        <UnstyledButton
          className={styles.zoomStep}
          onClick={() => setZoom(zoom + ZOOM_STEP)}
          disabled={zoom >= ZOOM_MAX}
          aria-label="Zoom in"
        >
          <Plus size={15} />
        </UnstyledButton>
      </Box>
    </Tooltip>
  );
};

export default ZoomControl;
